import BioExamResult from "core/models/bio-exam-result";
import Loinc from "core/models/loinc";
import trimLoincCode from "../trim-loinc-code";

// semeia-disable-reexport
export default function deduplicate(epsilon, results) {
  const duplicateIndexes = [];
  // Loop on both i and j to test each result with each other
  for (let i = 0; i < results.length; i++) {
    const resultI = results[i];
    for (let j = i + 1; j < results.length; j++) {
      const resultJ = results[j];
      // If the difference between the i-th value and the j-th value is below the threshold
      if (isDifferenceWithinThreshold(epsilon, resultI.value, resultJ.value)) {
        // Store both indexes in the `duplicateIndexes` array
        duplicateIndexes.push(i);
        duplicateIndexes.push(j);
      }
    }
  }

  // If `duplicateIndexes` is empty, it means that there is no duplicate
  if (!duplicateIndexes.length) {
    // Thus `results` are early returned
    return results;
  }

  // Make `duplicateIndexes` uniq
  const uniqIndexes = [...new Set(duplicateIndexes)];
  // Retrieve the index of the result to keep
  // It'll be the index of the first result found whose raw unit is the standard one
  // Otherwise it'll be 0
  const keptDuplicateIndex = uniqIndexes.find(index => rawUnitIsStandardUnit(results[index])) || 0;
  return results.map((res, index) => {
    // It's the result that will be kept as deduplicated => should not be updated
    if (index == keptDuplicateIndex) {
      return res;
    }

    // It means that the result is not a duplicate => it should not be updated
    if (!uniqIndexes.includes(index)) {
      return res;
    }

    // It means that this is a duplicate => should be set as ADHOC
    const loinc = trimLoincCode(res.code);
    res.code = BioExamResult.generateAdhocCode(loinc, "DUPLICATED");
    return res;
  });
}
function isDifferenceWithinThreshold(epsilon, value1, value2) {
  const difference = computeDifference(value1, value2);
  if (difference == undefined) return false;
  return difference <= epsilon;
}
function computeDifference(value1, value2) {
  if (!value1 || !value2) {
    return;
  }
  const float1 = parseNumber(value1);
  const float2 = parseNumber(value2);
  if (!float1 || !float2) {
    return;
  }
  return Math.max(float1, float2) / Math.min(float1, float2) - 1;
}
function parseNumber(number) {
  const parsedNumber = parseFloat(number.replace(",", ".").replace(" ", ""));
  if (isNaN(parsedNumber)) return;
  return parsedNumber;
}
function rawUnitIsStandardUnit(res) {
  const standardUnit = res.bioExamObservation.unit;
  // If the LOINC does not have standard unit return false
  if (!standardUnit) return false;
  // If the result does not have a raw unit return false
  if (!res.rawUnit) return false;

  // Otherwise return true if rawUnit & standardUnit are the same
  return res.rawUnit.toLowerCase() == standardUnit.toLowerCase();
}